import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { Cart } from '@shared/models/cart';
import { CartConfig } from '@shared/models/cart-config';
import { OfferingDiscount } from '@shared/models/offering-discount';
import { Period } from '@shared/types/period';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartsApiService {
  constructor(private apiService: ApiService) {}

  show(cart_id: string): Observable<{ data: Cart }> {
    return this.apiService.get(`v1/carts/${cart_id}`);
  }

  create(cartConfig: CartConfig): Observable<{ data: Cart }> {
    return this.apiService.post('v1/carts', { data: cartConfig });
  }

  auto_apply_offering_discounts(
    group_id: string,
    cart_id?: string,
    cart_item_id?: string,
  ): Observable<{ data: OfferingDiscount[] }> {
    return this.apiService.get(`v1/carts/auto_apply_offering_discounts`, {
      group_id: group_id,
      cart_id: cart_id,
      cart_item_id: cart_item_id,
    });
  }

  create_quotes(
    cart_id: string,
    periods: Period[],
    send_email: boolean,
    reference?: string,
    skip_external_creation?: boolean,
    custom_expiration_date?: string,
    reseller_quote_email_address?: string[],
    end_user_quote_email_address?: string[],
    opportunity_id?: number,
    preferred_period?: Period,
  ): Observable<{ data: { quote_ids: number[] } }> {
    return this.apiService.post(`v1/carts/${cart_id}/create_quotes`, {
      data: {
        periods: periods,
        send_email: send_email,
        reference: reference,
        skip_external_creation: skip_external_creation,
        custom_expiration_date: custom_expiration_date,
        reseller_quote_email_address: reseller_quote_email_address,
        end_user_quote_email_address: end_user_quote_email_address,
        opportunity_id: opportunity_id,
        preferred_period: preferred_period,
      },
    });
  }

  create_order(
    cart_id: string,
    period: Period,
    reference?: string,
    custom_expiration_date?: string,
    opportunity_id?: number,
  ): Observable<{ data: { quote_id: number } }> {
    return this.apiService.post(`v1/carts/${cart_id}/create_order`, {
      data: {
        period: period,
        reference: reference,
        custom_expiration_date: custom_expiration_date,
        opportunity_id: opportunity_id,
      },
    });
  }
}
